import { map } from "@thi.ng/transducers";
import { copyVectors } from "@thi.ng/vectors";
export const pointArraysAsShapes = (ctor, src, attribs) => src
    ? [...map((pts) => new ctor(copyVectors(pts), Object.assign({}, attribs)), src)]
    : undefined;
